import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateMaintenanceWindowScheduler = document.createElement('template');

templateMaintenanceWindowScheduler.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="form-wrapper">

    <gz-title fontSize="11" fontWeight="600" class="subsection-title" id="scheduler-title"/></gz-title>

    <div class='form-section'>

      <gz-form-field id='recurrence-form-field' class='label-mw-250' required>
          <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
          <gz-input-error></gz-input-error>
      </gz-form-field>

      <div class="details-container">

        <div class="form-section hidden" id="recurrence-weekly-container">
          <gz-form-field id='applies-every-weeks-form-field' class='label-mw-250' required>
            <div class="flex-group">
                <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
                <gz-title fontSize="12" fontWeight="300"></gz-title> <!-- weeks -->
                <gz-input-error></gz-input-error>
            </div>
          </gz-form-field>

          <gz-form-field id='weekly-on-form-field' class='label-mw-250' required>
              <gz-multiselect-group gz-form-input></gz-multiselect-group>
              <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

        <div class="form-section hidden" id="recurrence-monthly-container">
          <gz-form-field id='applies-every-months-form-field' class='label-mw-250' required>
           <div class="flex-group">
            <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
            <gz-title fontSize="12" fontWeight="300"></gz-title> <!-- months -->
            <gz-input-error></gz-input-error>
           </div>
          </gz-form-field>

          <div id="monthly-on-labeled-content">
              <div class="flex-group">
                <gz-title fontSize="12" fontWeight="300"></gz-title> <!-- on -->
                <gz-form-field id='monthly-frequency-form-field' class='label-mw-250' required>
                  <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
                  <gz-input-error></gz-input-error>
                </gz-form-field>
                <gz-form-field id='monthly-frequency-day-form-field' class='label-mw-250 hidden' required>
                  <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
                  <gz-input-error></gz-input-error>
                </gz-form-field>
                <gz-form-field id='monthly-frequency-day-number-form-field' required class='label-mw-250 hidden'>
                  <gz-input-number gz-form-input inputwidth="64" min="1" max="31"></gz-input-number>
                  <gz-input-error></gz-input-error>
                </gz-form-field>
              </div>
          </div>
        </div>

        <div id="common-fields-container">
          <gz-form-field id="starting-with-form-field" class='label-mw-250' label='' required>
            <gz-date-picker gz-form-input placeholder="day/month/year"></gz-date-picker>
            <gz-input-error></gz-input-error>
          </gz-form-field>

              <div id="between-labeled-content">
                <div class="flex-group">
                  <gz-title fontSize="12" id="between-label" fontWeight="300"></gz-title> <!-- between -->
                  <gz-form-field id="between-start-form-field"  required>
                    <gz-time-picker gz-form-input></gz-time-picker>
                    <gz-input-error></gz-input-error>
                  </gz-form-field>
                  <gz-title id="middle-label" fontSize="12" fontWeight="300"></gz-title> <!-- and -->
                  <gz-form-field id="between-end-form-field"  required>
                    <gz-time-picker gz-form-input></gz-time-picker>
                    <gz-input-error></gz-input-error>
                  </gz-form-field>
                </div>
              </div>
        </div>
      </div>
    </div>
    <br>
  </div>
`;
